module.exports = __webpack_public_path__ + "static/tomie-balogun-3e27767bb400c570446092255c42aacc.webp";